"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _breadcrumbContext = require("./breadcrumb-context");

/* eslint-disable import/no-extraneous-dependencies */
var useBreadcrumb = function useBreadcrumb(_ref) {
  var location = _ref.location,
      crumbLabel = _ref.crumbLabel,
      crumbSeparator = _ref.crumbSeparator,
      _ref$crumbStyle = _ref.crumbStyle,
      crumbStyle = _ref$crumbStyle === void 0 ? {} : _ref$crumbStyle,
      _ref$crumbActiveStyle = _ref.crumbActiveStyle,
      crumbActiveStyle = _ref$crumbActiveStyle === void 0 ? {} : _ref$crumbActiveStyle;

  var _React$useContext = _react.default.useContext(_breadcrumbContext.BreadcrumbContext),
      crumbs = _React$useContext.crumbs,
      updateCrumbs = _React$useContext.updateCrumbs;

  _react.default.useEffect(function () {
    updateCrumbs({
      location: location,
      crumbLabel: crumbLabel,
      crumbSeparator: crumbSeparator,
      crumbStyle: crumbStyle,
      crumbActiveStyle: crumbActiveStyle
    });
  }, [location, crumbLabel, crumbSeparator, crumbStyle, crumbActiveStyle, updateCrumbs]);

  return {
    crumbs: crumbs
  };
};

var _default = useBreadcrumb;
exports.default = _default;